import { AuthenticatedUser } from "../../types/user";
import { EmbedTheme } from "../../utils/embeds";
import { getDisplayName } from "../../utils/getDisplayName";
import { V3ProfileAvatar } from "../ProfileAvatar";
import { OptionalLink } from "../ReusableStyledComponents/OptionalLink";
import { VerticalSpacing } from "../VerticalSpacing";
import { EmbedAuthorName, EmbedAuthorWrapper } from "./V3EmbedAuthor.styles";

interface V3EmbedAuthorProps {
    author: AuthenticatedUser;
    embedTheme: EmbedTheme;
}

export const V3EmbedAuthor = ({ author, embedTheme }: V3EmbedAuthorProps) => {
    return (
        <VerticalSpacing bottom={18}>
            <OptionalLink href={author?.displayAuthoryPage ? `${process.env.NEXT_PUBLIC_FRONTEND_URL}/${author.slug}` : undefined} target="_blank">
                <EmbedAuthorWrapper>
                    <div>
                        <V3ProfileAvatar size={"XS"} src={author?.avatarUrl[0]?.url} authorName={getDisplayName(author)} />
                    </div>
                    <div>
                        <EmbedAuthorName embedTheme={embedTheme}>
                            <strong>{getDisplayName(author)}</strong>
                        </EmbedAuthorName>
                    </div>
                </EmbedAuthorWrapper>
            </OptionalLink>
        </VerticalSpacing>
    );
};
